<div class="epds_mat_override">
  <div class="gao_users_container" fxLayout="column" fxLayoutAlign="start start">
    <div fxLayout="row" style="width: 100%">
    <div class="gao-user-card" fxFlex *ngIf="!addOrEditInd">
      <mat-card>
        <mat-card-header>
          <mat-card-title role="heading" aria-level="1">Select GAO User</mat-card-title>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutAlign="start center">
          <mat-form-field appearance="outline" floatLabel="always" fxFlex>
            <mat-label>GAO User</mat-label>
            <mat-select [value]="selectedUser?.gao_user_id" placeholder="Please Select GAO User">
              <ng-container *ngFor="let group of groupedUsers | keyvalue">
                <mat-optgroup [label]="'Group ' + group.key">
                  <mat-option *ngFor="let user of group.value" [value]="user.gao_user_id" (click)="setSelectedUser(user.user_Id)">
                    {{ user.last_Name + ', ' + user.first_Name}}
                  </mat-option>
                </mat-optgroup>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="16px">
          <button mat-raised-button color="primary" (click)="setAddOrEditInd('A')">Register New GAO USER</button>
        </mat-card-actions>
      </mat-card>
    </div>
    </div>

    <div class="user-details-card" fxLayout="row" fxLayoutAlign="start start" style="width: 100%"
         *ngIf="selectedUser?.gao_user_id && !addOrEditInd">
      <mat-card appearance="outlined" fxFlex="50">
        <mat-card-header>
            <mat-card-title role="heading" aria-level="1" fxLayout="row" fxLayoutAlign="space-between">
              <section>{{ selectedUser?.first_Name }} {{ selectedUser?.last_Name }}</section>
              <section>Group # {{ selectedUser?.group_No }}</section>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutAlign="center" class="user-card-content">
          <div fxFlex="90" fxLayout="column" fxLayoutGap="8px">
            <p><strong>Phone Number:</strong> {{ selectedUser?.phone_No}}</p>
            <p><strong>Email:</strong> {{ selectedUser?.email}}</p>
            <p><strong>Firm Name:</strong> {{ selectedUser?.firm_Name}}</p>
            <p><strong>Address:</strong>
              <br>
              {{  selectedUser?.address1 +
                  (selectedUser?.address2 ? (', ' + selectedUser?.address2) : '')
              }}
              <br>
              <span>
                {{selectedUser?.city + ' ' + selectedUser?.zip_Code}}
              </span>
              <br>
              <span>
                {{selectedUser?.country}}
              </span>
            </p>
            <p><strong>Group #:</strong> {{ selectedUser?.group_No}}</p>
            <p><strong>GAO ID:</strong> {{ selectedUser?.gao_user_id}}</p>
            <p><strong>Role:</strong> {{ selectedUser?.role}}</p>
          </div>
        </mat-card-content>
        <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="16px">
          <button mat-raised-button color="warn" style="margin-top: 16px;" (click)="setAddOrEditInd('E')">
            <mat-icon>edit</mat-icon> Update</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>

  <ng-container *ngIf="selectedUser && addOrEditInd">
    <epds-add-or-edit-gao-user [user]="selectedUser" (btnClicked)="handleGAOuserForm($event)"
                               [addOrEditInd]="addOrEditInd" [saving]="saving"></epds-add-or-edit-gao-user>
  </ng-container>
</div>
